import api from "./api";

export const loginUser = (email, password) =>
  api.post("/auth/login", {}, {
    headers: { Authorization: `Basic ${btoa(`${email}:${password}`)}` }
  }).then((response) => response.data);

export const getCurrentUser = () =>
  api.get("/auth/me").then((response) => response.data);

export const registerUser = (payload) =>
  api.post("/auth/register", payload).then((response) => response.data);

export const getUsers = (params = {}) =>
  api.get("/auth/users", { params }).then((response) => response.data);

export const changePassword = (oldPassword, newPassword) =>
  api.post("/auth/password/change", {
    old_password: oldPassword,
    new_password: newPassword,
  }).then((response) => response.data);

export const forgotPassword = (email) =>
  api.post("/auth/password/forgot", { email }).then((response) => response.data);

export const resetPassword = (token, newPassword) =>
  api.post("/auth/password/reset", {
    token,
    new_password: newPassword,
  }).then((response) => response.data);
